var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13438 3.13438 0 7 0C10.8656 0 14 3.13438 14 7C14 10.8656 10.8656 14 7 14C3.13438 14 0 10.8656 0 7ZM1.1875 7C1.1875 10.2094 3.79063 12.8125 7 12.8125C10.2094 12.8125 12.8125 10.2094 12.8125 7C12.8125 3.79063 10.2094 1.1875 7 1.1875C3.79063 1.1875 1.1875 3.79063 1.1875 7ZM6.25 4.41667C6.25 4.83088 6.58579 5.16667 7 5.16667C7.41421 5.16667 7.75 4.83088 7.75 4.41667C7.75 4.00245 7.41421 3.66667 7 3.66667C6.58579 3.66667 6.25 4.00245 6.25 4.41667ZM7 6.16667C6.72386 6.16667 6.5 6.39052 6.5 6.66667V10.1667C6.5 10.4428 6.72386 10.6667 7 10.6667C7.27614 10.6667 7.5 10.4428 7.5 10.1667V6.66667C7.5 6.39052 7.27614 6.16667 7 6.16667Z",
    fill: "#4267F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.05dc7abd.svg";
export { ForwardRef as ReactComponent };